import { LmIconOutlineMiscDiamond } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionProforientationMetaskillsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineMiscDiamond {...rest} /> : <LmIconOutlineMiscDiamond {...rest} />;

export default IconProfessionProforientationMetaskillsCommon;
